export default __webpack_public_path__ + "static/media/lab_login-background.2b0d4e6a.jpeg";